import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "d-flex flex-row nowrap align-items-center",
  style: {"gap":"5px"}
}
const _hoisted_2 = ["disabled", "checked"]



type Value = string | number | boolean
type Option = {
    value: Value
    label: string
}

interface Props {
    disabled?: boolean
    error?: boolean
    option?: Option
    active: boolean
}
interface Emits {
    (e: 'checkboxClick', option?: Option): void
}

// props

export default /*@__PURE__*/_defineComponent({
  __name: 'Checkbox',
  props: {
    disabled: { type: Boolean },
    error: { type: Boolean },
    option: {},
    active: { type: Boolean }
  },
  emits: ["checkboxClick"],
  setup(__props: any, { emit: __emit }) {

const props = __props

// emit
const emit = __emit

// handlers
const handleClick = (e: any) => {
    emit('checkboxClick', e.target.value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", {
      class: "ts-form-check-input",
      disabled: props.disabled,
      type: "checkbox",
      checked: props.active,
      onChange: handleClick
    }, null, 40, _hoisted_2),
    _createElementVNode("label", null, [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _createTextVNode(_toDisplayString(props.option?.label || ""), 1)
      ])
    ])
  ]))
}
}

})